import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../helpers/fetch-wrapper";

/* Create slice */
const name = "activityLog";
const reducers = createReducers();
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

/* Exports */
export const activityLogActions = { ...slice.actions, ...extraActions };
export const activityLogReducer = slice.reducer;

/* Implementation */
function createInitialState() {
  return {
    value: null,
    sessionId: null,
  };
}

function createReducers() {
  return {
    setSessionId,
  };

  function setSessionId(state, action) {
    state.sessionId = action.payload || null;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    logActivity: logActivity(),
  };

  /* Log a guest-journey activity event */
  function logActivity() {
    return createAsyncThunk(
      `${name}/logActivity`,
      async (request) => await fetchWrapper.post(`${baseUrl}/activity-log`, request)
    );
  }
}
